<div *ngIf="user && user?.Roles && user?.Roles?.length && user?.IsMultiRole === true">
    <mat-form-field appearance="standard" style="padding:0;margin:0">
        <mat-select 
            matInput
            #multiRoleSelect 
            [class.mat-caption]="!isCaption"
            style="padding-top:0;margin-top:-10px;margin-bottom:0;padding-bottom:0"
            [(ngModel)]="user.CurrentRoleInfo" 
            (ngModelChange)="updateUser(multiRoleSelect.value)" 
            [compareWith]="compareFn"
            aria-label="User current role selection list">

            <mat-option *ngFor="let role of user?.Roles" [value]="role" style="font-size:16px;">
                <span *ngIf="role.IsDesignee === true">School Designee Access ({{role.WorkLocation}})</span>
                <span *ngIf="role.IsDeveloper === true">Multiple Pathways Developer Access</span>
                <span *ngIf="role.IsPrincipal === true">School Administrator Access ({{role.WorkLocation}})</span>
                <span *ngIf="role.IsAssistantPrincipal === true">School Administrator Access ({{role.WorkLocation}})</span>
                <span *ngIf="role.IsSystemAdmin === true">System Administrator Access</span>
                <span *ngIf="role.IsDistrictStaff === true">District Staff Access</span>
                <span *ngIf="role.IsProgramContact === true">Program Contact Access</span>
                <span *ngIf="role.IsCounselor === true">School Counselor Access</span>
                <span *ngIf="role.IsSuccessCoach === true">Success Coach Access</span>
                <span *ngIf="role.IsStudentAdvisor === true">Student Advisor Access</span>
                <span *ngIf="role.IsClearinghouse === true">Clearinghouse Team Access</span>
                <span *ngIf="role.IsReader === true">Application Reader Access</span>
            </mat-option>

        </mat-select>
    </mat-form-field>
</div>